import { DecimalPipe, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, LOCALE_ID, provideAppInitializer, provideZoneChangeDetection, inject } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptor/auth.interceptor';
import { RuntimeConfigService } from './core/services/runtime-config.service';
import {spsPresetPurple} from "./theme/spstheme-purple";
import localeDe from '@angular/common/locales/de';

registerLocaleData(localeDe);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAppInitializer(() => inject(RuntimeConfigService).load()),
    provideRouter(routes),
    // Deprecated -> switched to CSS animations, but still needed from PrimeNG 20 Components (Toast - for example)
    // could be removed with PrimeNG 21
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor])),
    // without interceptor
    // provideHttpClient(),
    // with Bearer token on gc-api
    // doesn't work because of proxy
    /*
    provideOAuthClient({
      resourceServer: {
        allowedUrls: ['https://dev.girocheckout.dsv-ffb.de'],
        sendAccessToken: true,
      }
    }),
     */
    // without Bearer token on gc-api => custom interceptor
    provideOAuthClient({
      resourceServer: {
        allowedUrls: [],
        sendAccessToken: false,
      }
    }),
    {provide: OAuthStorage, useValue: localStorage},
    MessageService,
    ConfirmationService,
    DecimalPipe,
    {provide: LOCALE_ID, useValue: 'de'},
    providePrimeNG({
      theme: {
        preset: spsPresetPurple,
        options: {
          darkModeSelector: false
        }
      }
    })
  ]
};
